import { ConditionOperatorEnum, type Condition } from '@repo/api-gw-sdk';

import { backupStatus } from '../queryBuilder/properties';

export const createBackupStatusNotInCondition = (
  values: string[]
): Condition => ({
  property: backupStatus.name,
  operator: ConditionOperatorEnum.NotIn,
  value: values,
});
